import * as T from '@/types'
import caseConverter from 'axios-case-converter'
import config from '@/config'
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'

const routes : {[key: string] : string} = {
    Login: 'user/login',
    ForgotPassword: 'user/forgot-your-password',
    ResetPassword: 'user/reset-password',
    SetPassword: 'user/set-password',
    Me: 'user/me',
    Index: 'user/me',
}

export class AuthResource {

    api: T.CreditorDeskApi

    constructor (api: T.CreditorDeskApi) {
        this.api = api
    }

    login (email: T.EmailAddress, password: string) {
        return this.api.post(routes.Login, { email, password })
    }

    forgotPassword (email: string) {
        return this.api.post(routes.ForgotPassword, { email })
    }
    
    resetPassword (token: string, password: string, passwordConfirmation: string, email?: string) {
        return this.api.post(routes.ResetPassword, { token, email, password, 'password_confirmation': passwordConfirmation }) // TODO use case converter
    }
    
    setPassword (token: string, password: string, passwordConfirmation: string) {
        const authorisedApi: T.CreditorDeskApi = caseConverter(axios.create({
            baseURL: `${config.API.URL}`,
    
            headers: {
                xApiKey: `${config.API.API_KEY}`,
                contentType: 'application/json',
                authorization: `Bearer ${token}`,
            },
        }),
        )
    
        return authorisedApi.post(routes.SetPassword, { password, passwordConfirmation })
    }

    me () {
        return this.api.get(routes.Me)
    }

}

export default function (api: T.CreditorDeskApi) {
    return new AuthResource(api)
}
